import { MfaSetupAtLoginError } from '@/auth/utils/cognitoMfaSetup';
import { CognitoSessionEndedError } from '@/auth/utils/cognitoSession';
import { ERROR_CODES } from '@/core/api';

import type { useSelfServiceSMBSignupFlow } from '../hooks/useSelfServiceSMBSignupFlow';

// ENG-6106: the flow error that ends the funnel on the sign-in panel. The
// account step already treats this code as "sign in to finish MFA setup".
export const SIGN_IN_REQUIRED_CODE = ERROR_CODES.AUTH_MFA_ENROLLMENT_REQUIRED;

type Flow = Pick<ReturnType<typeof useSelfServiceSMBSignupFlow>, 'setError'>;

// The Cognito session a funnel step was sent under ended before the step
// finished, so only a fresh sign-in can carry on.
export const SESSION_ENDED_MESSAGE = 'Your session ended. Please sign in again to finish setup.';

/** True for the errors endOnSignInRequired ends the funnel on. */
export function isSignInRequired(err: unknown): boolean {
  return err instanceof MfaSetupAtLoginError || err instanceof CognitoSessionEndedError;
}

/**
 * End the funnel on the sign-in panel when the api refused the session for
 * MFA setup (mfaSetupAtLogin has already signed out), or the Cognito session
 * ended under a step. True when it did, so the caller skips its ordinary
 * failure handling.
 */
export function endOnSignInRequired(flow: Flow, err: unknown): boolean {
  if (err instanceof MfaSetupAtLoginError) {
    flow.setError(SIGN_IN_REQUIRED_CODE, err.message);
    return true;
  }
  if (err instanceof CognitoSessionEndedError) {
    flow.setError(SIGN_IN_REQUIRED_CODE, SESSION_ENDED_MESSAGE);
    return true;
  }
  return false;
}
